// removed by extract-text-webpack-plugin
module.exports = {"StartChattingButtonWrapper":"StartChattingButtonWrapper__Ad0yg","StartChattingButton":"StartChattingButton__2wibJ","StartChattingText":"StartChattingText__30r2w","Header":"Header___ApPf"};


//////////////////
// WEBPACK FOOTER
// ./routes/StartChatting/style.scss
// module id = DlyD
// module chunks = 0